import { fetchInternalApiJson } from './internal-api.js';
import type { CloudFetchParams, SessionMetaJson } from './types.js';

export async function fetchCloudSessionMeta(
  params: CloudFetchParams & { sessionId: string },
): Promise<{ ok: true; data: SessionMetaJson } | { ok: false; error: string }> {
  return fetchInternalApiJson<SessionMetaJson>({
    ...params,
    path: `/internal/sessions/${encodeURIComponent(params.sessionId)}/meta`,
    errorLabel: 'Session meta fetch failed',
  });
}
